
    import '/opt/buildhome/repo/packages/x/components/actions/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["actions-demo-basic","actions-demo-sub","actions-demo-preset","actions-demo-variant","actions-demo-fadein","actions-demo-_semantic","actions-demo-_semantic-copy","actions-demo-_semantic-feedback","actions-demo-_semantic-audio","actions-demo-_semantic-item"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/actions/index.en-US.md?type=demo')
};